/**
 * Deal stage transitions.
 *
 * Split out of `../deal-validation.ts`. A deal is free to move between open
 * stages in either direction — the pipeline is a description, not a workflow —
 * but a TERMINAL stage (won, or any of the five lost stages) is frozen: those
 * are the rows revenue reporting reads, so re-opening one has to be a deliberate
 * act elsewhere, not a side effect of an `update_deal` call.
 */

import { DEAL_STAGE_VALUES, isLostDealStage, isValidDealStage } from '../../types/deal-tool.types';
import type { DealStage } from '../../types/deal-tool.types';

/** Validate stage transition */
export function validateStageTransition(currentStage: DealStage, newStage: DealStage): void {
  // The enum check comes first: an unknown target is a bad argument, not a
  // policy violation, and should say so.
  if (!isValidDealStage(newStage)) {
    throw new Error(`Invalid stage: ${newStage}`);
  }

  if (
    (currentStage === 'deal_won' || isLostDealStage(currentStage)) &&
    newStage !== currentStage
  ) {
    throw new Error(`Cannot transition from "${currentStage}" stage to "${newStage}"`);
  }
}

/** The stages an `update_deal` may name, in pipeline order. Re-exported for message text. */
export { DEAL_STAGE_VALUES };
